import * as React from 'react';
import { connect } from 'react-redux';

import { triggerVideo } from '../reducers/tutorial-videos';

import { VideoKind } from 'modules/help-menu/util/videos';

type StateProps = {
  isSelfService: boolean
};

type OwnProps = {
  event: string,
  eventDetails?: string,
  children: React.ReactNode | undefined | null
};

type DispatchProps = {
  dispatchTriggerVideo: (event: string) => void
};

type Props = StateProps & OwnProps & DispatchProps;

const moduleEventStore = {};

class ClickTutorialHandler extends React.PureComponent<Props> {
  handleClick = (): void => {
    const { dispatchTriggerVideo, event, eventDetails, isSelfService } = this.props;

    if (event === VideoKind.BULK_SHORTLIST_BULK_OFFER && isSelfService) {
      // have to track only second clicks in this case
      const eventTriggerKey = `click-event-${event}-${eventDetails || ''}`;
      const wasTriggered = moduleEventStore[eventTriggerKey];
      if (!wasTriggered) {
        // skip first click
        moduleEventStore[eventTriggerKey] = true;
        return;
      }
    }
    dispatchTriggerVideo(event);
  };

  render() {
    const { children } = this.props;
    return (
      <div onClick={this.handleClick}>
        {children}
      </div>
    );
  }
}

const mapStateToProps = ({ tutorialVideos }): StateProps => ({
  isSelfService: tutorialVideos.isSelfService
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchTriggerVideo: (event: string) => dispatch(triggerVideo(event))
});

export default connect(mapStateToProps, mapDispatchToProps)(ClickTutorialHandler);
